import { useCruiseListStore } from '..'
import { defaultAverageLineHeight } from '../filter/defaultValues'

export const calcListItemHeight = (itemHeights: number[]) => {
  const cruiseListStore = useCruiseListStore()

  let sum = 0
  let numItems = 0
  let averageLineHeight = defaultAverageLineHeight

  for (let i = 0; i < cruiseListStore.cruiseList.length; i++) {
    if (itemHeights[i] > 0) {
      sum += itemHeights[i]
      numItems++
    }
  }

  if (!!numItems && !!sum) {
    averageLineHeight = Math.round(sum / numItems)
  }

  cruiseListStore.averageLineHeight = averageLineHeight
  cruiseListStore.listItemHeight = itemHeights
}

export default {
  calcListItemHeight,
}